// DAS-2181 Phase 2: Terminal Analysis Panels — three-column summary strip
import React from 'react';
import { terminalZoneConfig, ANNOTATION_REGIONS } from './terminalZoneConfig';

const TerminalPanels = ({ panelData, onCardClick, annotationMode, onAnnotationClick, annotations = [] }) => {
  const panelConfig = terminalZoneConfig.panels;

  const dataMap = {
    risk_allocation: panelData?.riskPanel,
    fundamentals_signals: panelData?.fundamentalsPanel,
    timeline_alerts: panelData?.timelinePanel,
  };

  const getAnnotationCount = (panelId) =>
    annotations.filter(a => a.region.startsWith(`panels.${panelId}`) && a.status === 'open').length;

  const handlePanelClick = (panel, e) => {
    if (annotationMode) {
      e.stopPropagation();
      onAnnotationClick?.(ANNOTATION_REGIONS.panel(panel.id), panel.title);
      return;
    }
    if (panel.modal) onCardClick?.(panel.modal);
  };

  return (
    <div className="panels">
      {panelConfig.map((panel) => {
        const pd = dataMap[panel.id] || { badge: null, rows: [] };
        const annCount = getAnnotationCount(panel.id);
        const classes = ['panel'];
        if (annotationMode) classes.push('annotatable', 'annotation-mode');

        return (
          <div className={classes.join(' ')} key={panel.id}>
            <div className="p-head" onClick={(e) => handlePanelClick(panel, e)}>
              <span className="p-title">{panel.title}</span>
              {pd.badge && (
                <span className={`p-badge ${pd.badge.cls}`}>{pd.badge.text}</span>
              )}
              {annotationMode && annCount > 0 && <span className="annotation-badge">{annCount}</span>}
            </div>
            <div className="p-body">
              {pd.rows.map((row, idx) => {
                if (row.divider) return <div className="p-divider" key={`d-${idx}`} />;
                if (row.sectionLabel) return <div className="p-section-label" key={`s-${idx}`}>{row.sectionLabel}</div>;
                return (
                  <div className="p-row" key={row.key}>
                    <span className="p-key">{row.key}</span>
                    <span className={`p-val${row.cls ? ` ${row.cls}` : ''}`}>{row.value}</span>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TerminalPanels;
